import { Component, Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { ApiService } from '../../services/api.service';
import { IModal, IModalSaved, IModalError, IModalDelete } from '../../interfaces';
import { Location } from '@angular/common';
import { BodyClassService } from '../body-class.service';

@Injectable()
export class ModalService {

  constructor(
    private _location: Location,
    public _bc: BodyClassService,
    ) {}

  private _state = new Subject<any>();

  state = this._state.asObservable();

  open(data) {
    this._state.next({
      isOpen: true,
      data: data
    });
    this._bc.sendClasses('no-scroll');
  }

  close() {
    this._state.next({
      isOpen: false,
      data: {}
    });
    this._bc.sendClasses('no-scroll', false);
  }

  /************************************************************************
  this._ms.saved({
    view: () => { console.log('view' ) },
    continue: () => { console.log('close' ) },
    list: () => { console.log('list' ) },
  })
  ************************************************************************/
  saved(params: IModalSaved) {
    const data = {
      title: `Confirmation`,
      message: `Enregistrement effectué avec succès`,
      actions: [{
        action: () => { this.close(); if (params.view) {params.view()} },
        label: 'Voir',
        color: 'primary'
      }, {
        action: () => { this.close(); if (params.continue) {params.continue()} },
        label: 'Continuer',
        color: 'success'
      }, {
        action: () => { this.close(); if (params.list) {params.list()} },
        label: `Retourner à la liste`,
        color: 'primary'
      }]
    };
    this.open(data);
  }

  /************************************************************************
  this._ms.error({
    continue: () => { console.log('continue' ) }
  })
  ************************************************************************/
  error(params: IModalError = {}) {
    const data = {
      title: `Erreur`,
      message: 'Une ou plusieurs erreurs sont intervenues. <br/> Veuillez corriger les erreurs et resoumettre le formulaire',
      actions: [{
        action: () => { this.close(); if (params.continue) {params.continue()} },
        label: 'Ok',
        color: 'success'
      }]
    };
    this.open(data);
  }


  /************************************************************************
  this._ms.unknown()
  ************************************************************************/
  unknown() {
    const data = {
      title: 'Erreur',
      // message: 'Une erreur est survenue, veuillez Réessayez plus tard. <br/>Si le problème persiste, ouvrez un ticket au support.',
      message: 'Une erreur est survenue, veuillez Réessayez plus tard.',
      actions: [{
        action: () => { this.close(); },
        label: 'Fermer',
        color: 'primary'
      }]
    };
    this.open(data);
  }

  related(params) {
    const el = params.related[0];
    const message = params.related;
    const data = {
      title: `Attention, en supprimant ${el.model} N°${el.id} (${el.name}) vous supprimerez les éléments suivants :`,
      related: true,
      message: message,
      actions: [{
        action: () => { this.close(); if (params.continue) { params.continue(); } },
        label: 'Tout supprimer',
        color: 'success'
      }, {
        action: () => { this.close(); },
        label: 'Fermer',
        color: 'primary'
      }]
    };
    this.open(data);
  }


  /************************************************************************
  this._ms.missing()
  ************************************************************************/
  missing() {
    this._location.back();
    const data = {
      title: 'Objet non trouvé',
      message: `
        L'objet que vous recherchez est introuvable, il se peut qu'il ait été supprimé. <br/>
        Si le problème persiste, ouvrez un ticket au support.`,
      actions: [{
        action: () => { this.close(); },
        label: 'Fermer',
        color: 'success'
      }, {
        action: () => {
          this.close();
          this.submitTicket();
        },
        label: 'Ouvrir un ticket',
        color: 'primary'
      }]
    };
    this.open(data);
  }

  submitTicket(params:IModalError={}) {
    const data = {
      title: `Comment soumettre un ticket ?`,
      message: `
      <p>Voici quelques règles pour soumettre un ticket efficacement :</p>
      <ul>
      <li>- Un ticket doit correspondre à une problématique donnée.<br/>Si vous souhaitez soumettre deux problématiques, cela fait deux tickets.</li>
      <li>- Si le problème est visuel, il est préférable de mettre une capture d'écran</li>
      <li>- Préciser votre navigateur (Chrome, Firefox, Edge, ...)</li>
      <li>- Soyez le plus explicite possible, et contextualisez au mieux le problème : Quelles sont les étapes qui vous ont conduit à ce problème ?</li>
      </ul>
      <p>En cliquant <i>Ouvrir un ticket</i>, vous serez redirigé vers votre messagerie, vous pourrez alors mettre votre problématique en objet, et son descriptif dans le corps du mail.</p>.`,
      actions: [{
        action: () => { this.close(); if (params.continue) {params.continue()} },
        label: 'Annuler',
        color: 'primary'
      }, {
        action: () => { this.close(); window.open('mailto:incoming+e-reflex/locaboxe-front@gitlab.com', '_blank'); },
        label: 'Ouvrir un ticket',
        color: 'primary'
      }]
    };
    this.open(data);
  }

  delete(params: IModalDelete = {}) {
    const data = {
      title: `Suppression`,
      message: 'Êtes-vous sûr de vouloir supprimer cet élément ?<br/>Cette action est irréversible.',
      actions: [{
        action: () => { this.close(); if (params.confirm) {params.confirm()} },
        label: 'Confirmer',
        color: 'success'
      }, {
        action: () => { this.close(); if (params.cancel) {params.cancel()} },
        label: 'Annuler',
        color: 'danger'
      }]
    };
    this.open(data);
  }

}

@Component({
  selector: 'vq-modal',
  templateUrl: './vq-modal.component.html',
  styles: []
})
export class VQModalComponent implements OnInit {

  public isOpen = false;

  // @Input('data') data:IModal;

  data: any;

  constructor(
    private _ms: ModalService
    ) { }

  close() {
    this.isOpen = false;
    this._ms.close();
  }

  isArray(row) {
    if (Array.isArray(row)) {
      return true;
    }
    return false;
  }

  preventClick(event) {
    event.stopPropagation();
  }

  ngOnInit() {
    this._ms.state.subscribe((v) => { this.isOpen = v.isOpen; this.data = v.data; });
  }

}



// WEBPACK FOOTER //
// ./src/app/vqutils/vq-modal/vq-modal.component.ts